import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import UpcomingAppointmentListItem from './UpcomingAppointmentListItem';
import OverviewBoardHeader from './board/OverviewBoardHeader';
import VirtualFixedList from '../../shared/virtualization/VirtualFixedList';
import { ListRowSkeletonStack } from '../loading/skeletons';
import './styles/UpcomingAppointmentsCard.css';
import './board/OverviewBoard.css';

/** Matches `.upcoming-appt-row` min-height for virtual scroll sizing */
const UPCOMING_LIST_ROW_HEIGHT = 72;

const UpcomingAppointmentsCard = ({
  appointments,
  loading = false,
  onAppointmentClick,
  getServiceName,
}) => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate('/app/overview/appointments');
  };

  const renderItem = useCallback(
    (appointment) => (
      <UpcomingAppointmentListItem
        appointment={appointment}
        getServiceName={getServiceName}
        onClick={onAppointmentClick}
      />
    ),
    [getServiceName, onAppointmentClick]
  );

  return (
    <div className="upcoming-appointments-container overview-board">
      <OverviewBoardHeader
        eyebrow="Upcoming"
        title="Appointments"
        count={loading ? 'Loading appointments' : `${appointments?.length || 0} scheduled`}
        actionLabel="View"
        onAction={handleViewAll}
        actionTitle="View all appointments"
      />

      <div className="upcoming-appointments-content">
        {loading ? (
          <div className="upcoming-appointments-list-shell">
            <ListRowSkeletonStack rows={6} variant="upcoming" label="Loading upcoming appointments" />
          </div>
        ) : appointments && appointments.length > 0 ? (
          <div className="upcoming-appointments-list-shell">
            <VirtualFixedList
              className="upcoming-appointments-virtual-list"
              listClassName="upcoming-appointments-list"
              items={appointments}
              itemHeight={UPCOMING_LIST_ROW_HEIGHT}
              itemGap={0}
              renderItem={renderItem}
              ariaLabel="Upcoming appointments"
              emptyFallback={(
                <div className="upcoming-appointments-empty">
                  <p>No upcoming appointments</p>
                </div>
              )}
            />
          </div>
        ) : (
          <div className="upcoming-appointments-empty">
            <p>No upcoming appointments</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UpcomingAppointmentsCard;
